import React from "react"
//import Slider from "react-slick";
//https://jsfiddle.net/marvelousowl/jtccpz6a/

let timeouts = {};
class FiltersActive extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            module_menu_show        : "hide-panel",
            panel_menu_show         : "hide-panel",
            prev_slide              : 0,
            filter_proper_active    : "hide",
            filters_group : {
                time : {
                    show : "hide"
                },
                brand: {
                    show : "hide"
                },
                line_business : {
                    show : "hide"
                },
                property : {
                    show : "hide"
                },
                region : {
                    show : "hide"
                },
                plan : {
                    show : "hide"
                },
                type_reserve : {
                    show : "hide"
                },
                room_type : {
                    show : "hide"
                },
                tariff_type : {
                    show : "hide"
                },
                channel : {
                    show : "hide"
                },
                agency : {
                    show : "hide"
                },
                market : {
                    show : "hide"
                },
                days : {
                    show : "hide"
                }
            }
        };
    }
    
    removeFilterActive(type, value){
        this.props.app.setFiltersComponent(type, value)
    }

    filterState(key, items){
        if(items.length > 3){
            return this.state.filters_group[key].show;
        }else{ 
            return "";
        }
    }
    setGroupState(key, action){
        let filters_group = this.state.filters_group;
        
        if(action === "default"){
            filters_group[key].show = "fade in";
            this.setState({
                filters_group : filters_group
            })
        }else if(action === "close"){
            filters_group[key].show = "hide";
            this.setState({
                filters_group : filters_group
            })
        }
    }
    render(){
        let properties = this.props.app.state.current_filter_properties;
        let time_filters = this.props.app.state.current_filter_time;
        let regions = this.props.app.state.current_filter_region;
        let reserves = this.props.app.state.current_filter_reserve;
        let business = this.props.app.state.current_filter_business;
        let brand = this.props.app.state.current_filter_brand;
        let plan = this.props.app.state.current_filter_plan;
        //let segment         = this.props.app.state.current_filter_segment;
        let type_room = this.props.app.state.current_filter_type_room;
        let type_tariff = this.props.app.state.current_filter_type_tariff;
        let channel = this.props.app.state.current_filter_channel;
        let agency = this.props.app.state.current_filter_agency;
        let market = this.props.app.state.current_filter_market;
        let days = this.props.app.state.current_filter_days;


        const listItemsTime = Object.keys(time_filters).map((key) =>
            <div className="filter-apply">
                <span className="description-filter">{time_filters[key].time}</span>
                <a className="remove-item" id={time_filters[key].value} onClick={this.removeFilterActive.bind(this, "time", time_filters[key].value)}/>
            </div>
        );

        const listItemsProperties = Object.keys(properties).map((key) =>
            <div className="filter-apply">
                <span className="description-filter">{properties[key].hotel}</span>
                <a className="remove-item" id={properties[key].value} onClick={this.removeFilterActive.bind(this, "property", properties[key].value)}/>
            </div>
        );

        const listItemsRegion = Object.keys(regions).map((key) =>
            <div className="filter-apply">
                <span className="description-filter">{regions[key].region}</span>
                <a className="remove-item" id={regions[key].value} onClick={this.removeFilterActive.bind(this, "region", regions[key].value)}/>
            </div>
        );

        const listItemsReserve = Object.keys(reserves).map((key) =>
            <div className="filter-apply">
                <span className="description-filter">{reserves[key].reserve}</span>
                <a className="remove-item" id={reserves[key].value} onClick={this.removeFilterActive.bind(this, "reserve", reserves[key].value)}/>
            </div>
        );

        const listItemsBusiness = Object.keys(business).map((key) =>
            <div className="filter-apply">
                <span className="description-filter">{business[key].business}</span>
                <a className="remove-item" id={business[key].value} onClick={this.removeFilterActive.bind(this, "business", business[key].value)}/>
            </div>
        );
        
        const listItemsBrand = Object.keys(brand).map((key) =>
            <div className="filter-apply">
                <span className="description-filter">{brand[key].brand}</span>
                <a className="remove-item" id={brand[key].value} onClick={this.removeFilterActive.bind(this, "brand", brand[key].value)}/>
            </div>
        );

        const listItemsPlan = Object.keys(plan).map((key) =>
            <div className="filter-apply">
                <span className="description-filter">{plan[key].plan}</span>
                <a className="remove-item" id={plan[key].value} onClick={this.removeFilterActive.bind(this, "plan", plan[key].value)}/>
            </div>
        );

        /*const listItemsSegment = Object.keys(segment).map((key) =>
            <div className="filter-apply">
                <span className="description-filter">{segment[key].segment}</span>
                <a className="remove-item" id={segment[key].value} onClick={this.removeFilterActive.bind(this, "segment", segment[key].value)}>
                    <i className="fa fa-times" aria-hidden="true"></i>
                </a>
            </div>
        );*/
        const listItemsTypeRoom = Object.keys(type_room).map((key) =>{
            const hotel = key.split("||")[1];
            return (<div className="filter-apply">
                <span className="description-filter">{type_room[key].type_room + " (" + hotel + ")"}</span>
                <a className="remove-item" id={type_room[key].value} onClick={this.removeFilterActive.bind(this, "type_room", type_room[key].value)}/>
            </div>)
        });

        const listItemsAgency= Object.keys(agency).map((key) =>
            <div className="filter-apply">
                <span className="description-filter">{agency[key].agency}</span>
                <a className="remove-item" id={agency[key].value} onClick={this.removeFilterActive.bind(this, "agency", agency[key].value)}/>
            </div>
        );

        const listItemsMarket = Object.keys(market).map((key) =>
            <div className="filter-apply">
                <span className="description-filter">{market[key].market}</span>
                <a className="remove-item" id={market[key].value} onClick={this.removeFilterActive.bind(this, "market", market[key].value)}/>
            </div>
        );

        const listItemsTypeTariff = Object.keys(type_tariff).map((key) =>
            <div className="filter-apply">
                <span className="description-filter">{type_tariff[key].type_tariff}</span>
                <a className="remove-item" id={type_tariff[key].value} onClick={this.removeFilterActive.bind(this, "type_tariff", type_tariff[key].value)}/>
            </div>
        );

        const listItemsChannel = Object.keys(channel).map((key) =>
            <div className="filter-apply">
                <span className="description-filter">{channel[key].channel}</span>
                <a className="remove-item" id={channel[key].value} onClick={this.removeFilterActive.bind(this, "channel", channel[key].value)}/>
            </div>
        );

        const listItemsDays = Object.keys(days).map((key) =>
            <div className="filter-apply">
                <span className="description-filter">{days[key].day}</span>
                <a className="remove-item" id={days[key].value} onClick={this.removeFilterActive.bind(this, "day", days[key].value)}/>
            </div>
        );
        
        return(
            <section id="container-filters-active" className={"filters-active "}>
                <div className={"filter-bubble " + (Object.keys(listItemsBrand).length > 0 ? "" : "hide") }>
                    <span className={"title " + (this.filterState("brand", Object.keys(listItemsBrand)) === "hide" ? "box-type" : "")}>
                        Brand/Group
                        { 
                            this.filterState("brand", Object.keys(listItemsBrand)) === "hide" ? 
                                <span> ({Object.keys(listItemsBrand).length}) <span className="show-filters-active" onClick={this.setGroupState.bind(this, "brand")} /> </span> :
                                ""
                        }

                                { 
                                    this.filterState("brand", Object.keys(listItemsBrand)) !== "hide" ? 
                                    <span className={"hide-filters-active " + (Object.keys(listItemsBrand).length < 4 ? "hide" : "" )} onClick={this.setGroupState.bind(this, "brand", "close")} />
                                    : ""
                                }
                    </span>
                    
                    <div 
                        className={"content-filters " + this.filterState("brand", Object.keys(listItemsBrand))} 
                        onMouseLeave={this.setGroupState.bind(this, "brand", "leave")}
                        onMouseEnter={this.setGroupState.bind(this, "brand", "enter")}>
                        
                        {listItemsBrand}
                    </div>
                </div>
                {
                    this.props.app.state.show_time_compare === true ? 
                        <div className={"filter-bubble " + (Object.keys(time_filters).length > 0 ? "" : "hide") }>
                            <span className={"title " + (this.filterState("time", Object.keys(listItemsTime)) === "hide" ? "box-type" : "")}>
                                {this.props.app.state.panel === "lead-time" ? "INTERVALO DE TIEMPO" : " COMPARATIVE TIME" }
                                { 
                                    this.filterState("time", Object.keys(listItemsTime)) === "hide" ? 
                                        <span> ({Object.keys(listItemsTime).length}) <span className="show-filters-active" onClick={this.setGroupState.bind(this, "time", "default")} /> </span> :
                                        ""
                                }
                                { 
                                    this.filterState("time", Object.keys(listItemsTime)) !== "hide" ? 
                                    <span className={"hide-filters-active " + (Object.keys(listItemsTime).length < 4 ? "hide" : "" )} onClick={this.setGroupState.bind(this, "time", "close")} />
                                    : ""
                                }
                            </span>
                            <div 
                                className={"content-filters " + this.filterState("time", Object.keys(listItemsTime))} 
                                onMouseLeave={this.setGroupState.bind(this, "time", "leave")}
                                onMouseEnter={this.setGroupState.bind(this, "time", "enter")}>
                                
                                {listItemsTime}
                            </div>
                        </div>
                    : ""
                }

                <div className={"filter-bubble " + (Object.keys(listItemsProperties).length > 0 ? "" : "hide") }>
                    <span className={"title " + (this.filterState("property", Object.keys(listItemsProperties)) === "hide" ? "box-type" : "")}>
                        Properties
                        { 
                            this.filterState("property", Object.keys(listItemsProperties)) === "hide" ? 
                                <span> ({Object.keys(listItemsProperties).length}) <span className="show-filters-active" onClick={this.setGroupState.bind(this, "property", "default")} /> </span> :
                                ""
                        }
                        { 
                            this.filterState("property", Object.keys(listItemsProperties)) !== "hide" ? 
                            <span className={"hide-filters-active " + (Object.keys(listItemsProperties).length < 4 ? "hide" : "" )} onClick={this.setGroupState.bind(this, "property", "close")} />
                            : ""
                        }
                    </span>
                    
                    <div 
                        className={"content-filters " + this.filterState("property", Object.keys(listItemsProperties))} 
                        onMouseLeave={this.setGroupState.bind(this, "property", "leave")}
                        onMouseEnter={this.setGroupState.bind(this, "property", "enter")}>
                        
                        {listItemsProperties}
                    </div>
                </div>
                <div className={"filter-bubble " + (Object.keys(listItemsRegion).length > 0 ? "" : "hide") }>
                    <span className={"title " + (this.filterState("region", Object.keys(listItemsRegion)) === "hide" ? "box-type" : "")}>
                        Region
                        { 
                            this.filterState("region", Object.keys(listItemsRegion)) === "hide" ? 
                                <span> ({Object.keys(listItemsRegion).length}) <span className="show-filters-active" onClick={this.setGroupState.bind(this, "region", "default")} /> </span> :
                                ""
                        }
                        { 
                            this.filterState("region", Object.keys(listItemsRegion)) !== "hide" ? 
                            <span className={"hide-filters-active " + (Object.keys(listItemsRegion).length < 4 ? "hide" : "" )} onClick={this.setGroupState.bind(this, "region", "close")} />
                            : ""
                        }
                    </span>
                    
                    <div 
                        className={"content-filters " + this.filterState("region", Object.keys(listItemsRegion))} 
                        onMouseLeave={this.setGroupState.bind(this, "region", "leave")}
                        onMouseEnter={this.setGroupState.bind(this, "region", "enter")}>
                        
                        {listItemsRegion}
                    </div>
                </div>
                <div className={"filter-bubble " + (Object.keys(listItemsReserve).length > 0 ? "" : "hide") }>
                    <span className={"title " + (this.filterState("type_reserve", Object.keys(listItemsReserve)) === "hide" ? "box-type" : "")}>
                        Reservation status
                        { 
                            this.filterState("type_reserve", Object.keys(listItemsReserve)) === "hide" ? 
                                <span> ({Object.keys(listItemsReserve).length}) <span className="show-filters-active" onClick={this.setGroupState.bind(this, "type_reserve", "default")} /> </span> :
                                ""
                        }
                        { 
                            this.filterState("type_reserve", Object.keys(listItemsReserve)) !== "hide" ? 
                            <span className={"hide-filters-active " + (Object.keys(listItemsReserve).length < 4 ? "hide" : "" )} onClick={this.setGroupState.bind(this, "type_reserve", "close")} />
                            : ""
                        }
                    </span>
                    <div 
                        className={"content-filters " + this.filterState("type_reserve", Object.keys(listItemsReserve))} 
                        onMouseLeave={this.setGroupState.bind(this, "type_reserve", "leave")}
                        onMouseEnter={this.setGroupState.bind(this, "type_reserve", "enter")}>
                        
                        {listItemsReserve}
                    </div>
                </div>
                <div className={"filter-bubble " + (Object.keys(listItemsBusiness).length > 0 ? "" : "hide") }>
                    <span className={"title " + (this.filterState("line_business", Object.keys(listItemsBusiness)) === "hide" ? "box-type" : "")}>
                        Business unit
                        { 
                            this.filterState("line_business", Object.keys(listItemsBusiness)) === "hide" ? 
                                <span> ({Object.keys(listItemsBusiness).length}) <span className="show-filters-active" onClick={this.setGroupState.bind(this, "line_business", "default")} /> </span> :
                                ""
                        }
                        { 
                            this.filterState("line_business", Object.keys(listItemsBusiness)) !== "hide" ? 
                            <span className={"hide-filters-active " + (Object.keys(listItemsBusiness).length < 4 ? "hide" : "" )} onClick={this.setGroupState.bind(this, "line_business", "close")} />
                            : ""
                        }
                    </span>
                    
                    <div 
                        className={"content-filters " + this.filterState("line_business", Object.keys(listItemsBusiness))} 
                        onMouseLeave={this.setGroupState.bind(this, "line_business", "leave")}
                        onMouseEnter={this.setGroupState.bind(this, "line_business", "enter")}>
                        
                        {listItemsBusiness}
                    </div>
                </div>
                <div className={"filter-bubble " + (Object.keys(listItemsPlan).length > 0 ? "" : "hide") }>
                    <span className={"title " + (this.filterState("plan", Object.keys(listItemsPlan)) === "hide" ? "box-type" : "")}>
                        Plan type
                        { 
                            this.filterState("plan", Object.keys(listItemsPlan)) === "hide" ? 
                                <span> ({Object.keys(listItemsPlan).length}) <span className="show-filters-active" onClick={this.setGroupState.bind(this, "plan", "default")} /> </span> :
                                ""
                        }
                        { 
                            this.filterState("plan", Object.keys(listItemsPlan)) !== "hide" ? 
                            <span className={"hide-filters-active " + (Object.keys(listItemsPlan).length < 4 ? "hide" : "" )} onClick={this.setGroupState.bind(this, "plan", "close")} />
                            : ""
                        }
                    </span>
                    
                    <div 
                        className={"content-filters " + this.filterState("plan", Object.keys(listItemsPlan))} 
                        onMouseLeave={this.setGroupState.bind(this, "plan", "leave")}
                        onMouseEnter={this.setGroupState.bind(this, "plan", "enter")}>
                        
                        {listItemsPlan}
                    </div>
                </div>
                { /*<div className={"filter-bubble " + (Object.keys(listItemsSegment).length > 0 ? "" : "hide") }>
                    <span className="title">
                        SEGMENTOS
                    </span>
                    <div className="content-filters">
                        {listItemsSegment}
                    </div>
                </div>*/ }
                <div className={"filter-bubble " + (Object.keys(listItemsTypeRoom).length > 0 ? "" : "hide") }>
                    <span className={"title " + (this.filterState("room_type", Object.keys(listItemsTypeRoom)) === "hide" ? "box-type" : "")}>
                        Service
                        { 
                            this.filterState("room_type", Object.keys(listItemsTypeRoom)) === "hide" ? 
                                <span> ({Object.keys(listItemsTypeRoom).length}) <span className="show-filters-active" onClick={this.setGroupState.bind(this, "room_type", "default")} /> </span> :
                                ""
                        }
                        { 
                            this.filterState("room_type", Object.keys(listItemsTypeRoom)) !== "hide" ? 
                            <span className={"hide-filters-active " + (Object.keys(listItemsTypeRoom).length < 4 ? "hide" : "" )} onClick={this.setGroupState.bind(this, "room_type", "close")} />
                            : ""
                        }
                    </span>
                    
                    <div 
                        className={"content-filters " + this.filterState("room_type", Object.keys(listItemsTypeRoom))} 
                        onMouseLeave={this.setGroupState.bind(this, "room_type", "leave")}
                        onMouseEnter={this.setGroupState.bind(this, "room_type", "enter")}>
                        
                        {listItemsTypeRoom}
                    </div>
                </div>
                
                <div className={"filter-bubble " + (Object.keys(listItemsTypeTariff).length > 0 ? "" : "hide") }>
                    <span className={"title " + (this.filterState("tariff_type", Object.keys(listItemsTypeTariff)) === "hide" ? "box-type" : "")}>
                        Tariff type
                        { 
                            this.filterState("tariff_type", Object.keys(listItemsTypeTariff)) === "hide" ? 
                                <span> ({Object.keys(listItemsTypeTariff).length}) <span className="show-filters-active" onClick={this.setGroupState.bind(this, "tariff_type", "default")} /> </span> :
                                ""
                        }
                        { 
                            this.filterState("tariff_type", Object.keys(listItemsTypeTariff)) !== "hide" ? 
                            <span className={"hide-filters-active " + (Object.keys(listItemsTypeTariff).length < 4 ? "hide" : "" )} onClick={this.setGroupState.bind(this, "tariff_type", "close")} />
                            : ""
                        }
                    </span>
                    
                    <div 
                        className={"content-filters " + this.filterState("room_type", Object.keys(listItemsTypeTariff))} 
                        onMouseLeave={this.setGroupState.bind(this, "tariff_type", "leave")}
                        onMouseEnter={this.setGroupState.bind(this, "tariff_type", "enter")}>
                        
                        {listItemsTypeTariff}
                    </div>
                </div>

                <div className={"filter-bubble " + (Object.keys(listItemsChannel).length > 0 ? "" : "hide") }>
                    <span className={"title " + (this.filterState("channel", Object.keys(listItemsChannel)) === "hide" ? "box-type" : "")}>
                        Agencies
                        { 
                            this.filterState("channel", Object.keys(listItemsChannel)) === "hide" ? 
                                <span> ({Object.keys(listItemsChannel).length}) <span className="show-filters-active" onClick={this.setGroupState.bind(this, "channel", "default")} /> </span> :
                                ""
                        }
                        { 
                            this.filterState("channel", Object.keys(listItemsChannel)) !== "hide" ? 
                            <span className={"hide-filters-active " + (Object.keys(listItemsChannel).length < 4 ? "hide" : "" )} onClick={this.setGroupState.bind(this, "channel", "close")} /> 
                            : ""
                        }
                    </span>
                    
                    <div 
                        className={"content-filters " + this.filterState("channel", Object.keys(listItemsChannel))} 
                        onMouseLeave={this.setGroupState.bind(this, "channel", "leave")}
                        onMouseEnter={this.setGroupState.bind(this, "channel", "enter")}>
                        
                        {listItemsChannel}
                    </div>
                </div>


                <div className={"filter-bubble " + (Object.keys(listItemsMarket).length > 0 ? "" : "hide") }>
                    <span className={"title " + (this.filterState("market", Object.keys(listItemsMarket)) === "hide" ? "box-type" : "")}>
                        Market
                        { 
                            this.filterState("market", Object.keys(listItemsMarket)) === "hide" ? 
                                <span> ({Object.keys(listItemsMarket).length}) <span className="show-filters-active" onClick={this.setGroupState.bind(this, "market", "default")} /> </span> :
                                ""
                        }
                        { 
                            this.filterState("market", Object.keys(listItemsMarket)) !== "hide" ? 
                            <span className={"hide-filters-active " + (Object.keys(listItemsMarket).length < 4 ? "hide" : "" )} onClick={this.setGroupState.bind(this, "market", "close")} />
                            : ""
                        }
                    </span>
                    
                    <div 
                        className={"content-filters " + this.filterState("room_type", Object.keys(listItemsMarket))} 
                        onMouseLeave={this.setGroupState.bind(this, "market", "leave")}
                        onMouseEnter={this.setGroupState.bind(this, "market", "enter")}>
                        
                        {listItemsMarket}
                    </div>
                </div>
                <div className={"filter-bubble " + (Object.keys(listItemsDays).length > 0 ? "" : "hide") }>
                    <span className={"title " + (this.filterState("days", Object.keys(listItemsDays)) === "hide" ? "box-type" : "")}>
                        Days
                        { 
                            this.filterState("days", Object.keys(listItemsDays)) === "hide" ? 
                                <span> ({Object.keys(listItemsDays).length}) <span className="show-filters-active" onClick={this.setGroupState.bind(this, "days", "default")} /> </span> :
                                ""
                        }
                        { 
                            this.filterState("days", Object.keys(listItemsDays)) !== "hide" ? 
                            <span className={"hide-filters-active " + (Object.keys(listItemsDays).length < 4 ? "hide" : "" )} onClick={this.setGroupState.bind(this, "days", "close")} />
                            : ""
                        }
                    </span>
                    
                    <div 
                        className={"content-filters " + this.filterState("room_type", Object.keys(listItemsDays))} 
                        onMouseLeave={this.setGroupState.bind(this, "days", "leave")}
                        onMouseEnter={this.setGroupState.bind(this, "days", "enter")}>
                        
                        {listItemsDays}

                    </div>
                </div>
                
            </section>
        )
    }
};
export default FiltersActive


// WEBPACK FOOTER //
// ./src/Frontend/components/FiltersActive.js